import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Tag,
  Pagination,
  Spin,
  Modal,
} from "antd";
import Highlighter from "react-highlight-words";
import _ from "lodash";
import { ConsoleSqlOutlined, SearchOutlined } from "@ant-design/icons";
import { professionalAction, userActions } from "../../_actions";
import { FindGhatakSearchTable } from "./FindGhatakSearchTable";
import { ImageView } from "../image/imageView";
import { LanguageContext } from "../../context/LanguageContext";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import { connect } from "react-redux";
import { roleAction } from "../../_actions/roleby.action";

const FindAccusedSearchTable = (props) => {
  const [criminalData, setCriminalData] = useState([]);
  const [searchInput, setsearchInput] = useState();
  const [criminalHeaders, setCriminalHeaders] = useState([]);
  const [searchText, setsearchText] = useState("");
  const [searchedColumn, setsearchedColumn] = useState("");
  const [page, setPage] = useState(0);
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [name, setName] = useState();
  const [showGunaDetails, setshowGunaDetails] = useState(false);
  const { t } = useContext(LanguageContext);
  const [gunaLoading, setGunaLoading] = useState(false);

  const showGunaViewModel = () => {
    setshowGunaDetails(true);
  };
  const closeGunaViewModel = () => {
    setshowGunaDetails(false);
  };
  const onGunaForm = (data) => {
    showGunaViewModel();
    if (data) {
      setGunaLoading(true);
      props.dispatch({
        type: "GET_CRIMINALS_BY_ID_SUCCESS",
        criminalViewList: {},
      });
      props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      gunaLoading &&
      props.professionals?.criminalViewList &&
      Object.keys(props.professionals.criminalViewList).length > 0
    ) {
      setGunaLoading(false);
    }
  }, [props.professionals?.criminalViewList]);

  const openImageModal = (img, name) => {
    setImageOpen(true);
    setSelectedImage(img);
    setName(name);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
    setName(null);
  };

  const requiredKeys = [
    "Sr.No",
    "age",
    "districtName",
    // "gunhaCount",
  ];
  const requiredKeysTitle = [
    t("sr.no"),
    t("age"),
    t("accused_police_station"),
    // t("total_crimes"),
  ];

  const searchdata = (search) => {
    if (search) {
      console.log("this.props search", props);
      if (props?.user?.role === "4") {
        professionalAction
          .getCriminalsAppInfoByCitySerach(
            props.cityid,
            search,
            page,
            props.pageSize
          )
          .then((res) => {
            //professionalAction.getCriminalsTableInfoById('cityId', this.props.user.cityId).then((res) => {
            res &&
              res.text().then((criminalList1) => {
                let criminal = JSON.parse(criminalList1);
                let list = criminal.dataItem;
                let columns1 =
                  list &&
                  list &&
                  list.map((itemObj, index) => {
                    return {
                      ...itemObj,
                      // key: index + 1,
                    };
                  });

                // columns1 && columns1.length && columns1.reverse();

                let tempObj = columns1.map((res, index) => {
                  return {
                    ...res,
                    photo:
                      res.photo && res.photo[0] && res.photo[0].length
                        ? res.photo[0]
                        : null,
                    "Sr.No": props.getSerialNumber(index, page, props.pageSize),
                  };
                });
                setCriminalData(tempObj);
                console.log("setCriminalData", tempObj);
              });
          });
      }
      if (props.user?.role === "9" || props.user?.role === "10") {
        const temp = {
          districtIds: props.user.map_districtId,
          search: search,
          page: page,
          size: props.pageSize,
        };
        roleAction.getCriminalsAppInfoSearchByrole(temp).then((res) => {
          //professionalAction.getCriminalsTableInfoById('cityId', this.props.user.cityId).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.dataItem;
              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                    // key: index + 1,
                  };
                });

              // columns1 && columns1.length && columns1.reverse();

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                  photo:
                    res.photo && res.photo[0] && res.photo[0].length
                      ? res.photo[0]
                      : null,
                  "Sr.No": props.getSerialNumber(
                    index,
                    props.current,
                    props.pageSize
                  ),
                };
              });
              setCriminalData(tempObj);
              console.log("setCriminalData", tempObj);
            });
        });
      }
    }
  };

  const requiredSortColumn = ["gunhaCount", "age"];
  const requiredSerchColumn = ["mobileNumber", "name", "districtName"];
  const requiredFilterColumn = ["photo"];
  const requiredSearchAndSort = ["name"];
  const users = props.usersData;
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          //   ref={(node) => {
          //     setsearchInput(node);
          //   }}
          placeholder={`Search ${dataIndex}`}
          value={props.search ? props.search : selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            handleSearch(selectedKeys, confirm, dataIndex);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(e) => {
              console.log("e,target", e.target.value);
              handleSearch(selectedKeys, confirm, dataIndex);
              searchdata(selectedKeys[0]);
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            {t("search")}
          </Button>
          <Button
            onClick={() => {
              handleReset(clearFilters);
              clear();
            }}
            size="small"
            style={{ width: 90 }}
          >
            {t("clear")}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = async (selectedKeys, confirm, dataIndex) => {
    confirm();
    setsearchText(selectedKeys[0]);
    setsearchedColumn(dataIndex);
  };

  //  let columns = criminalHeaders.map((res, index) => {
  //    let column = { ...res };

  //    // Customize "Sr.No" column
  //    if (res.title === "Sr.No") {
  //      column = {
  //        ...column,
  //        title: t("sr.no"),
  //        dataIndex: "Sr.No",
  //        key: "Sr.No",
  //        render: (text, record) => <span>{record.Sr.No}</span>,
  //      };
  //    }

  //    return column;
  //  });
  //   const srNoIndex = columns.findIndex((col) => col.key === "Sr.No");

  //   // Create the "name" column
  //   const nameColumn = {
  //     title: t("name"),
  //     key: "name",
  //     render: (text, record) => <span title={record.id}>{record.name}</span>,
  //   };

  //   // Insert the name column after "Sr.No"
  //   if (srNoIndex !== -1) {
  //     columns.splice(srNoIndex + 1, 0, nameColumn);
  //   } else {
  //     // Fallback: if "Sr.No" not found, push at the end
  //     columns.push(nameColumn);
  //   }

  let columns = [];
  columns.push(
    {
      title: t("sr.no"),
      dataIndex: "Sr.No",
      key: "Sr.No",
      render: (text, record) => <span>{record["Sr.No"]}</span>,
    },
    {
      title: t("name"),
      dataIndex: "name",
      key: "name",
      render: (text, record) => <span title={record?.id}>{record.name}</span>,
    },

    {
      title: t("age"),
      dataIndex: "age",
      key: "age",
      render: (text, record) => <span>{record.age}</span>,
    },
    {
      title: t("accused_police_station"),
      dataIndex: "name",
      key: "name",
      render: (text, record) => <span>{record.districtName}</span>,
    },
    {
      title: t("total_crimes"),
      key: "gunhaCount",
      render: (text, record) => (
        <div className="action-links-responsive">
          <Button
            type="text"
            size="small"
            className="action-link update-link"
            onClick={() => {
              onGunaForm(record.id);
            }}
          >
            {record.totalCrimeCount
              ? record?.totalCrimeCount
              : record?.gunhaCount}
          </Button>
        </div>
      ),
    }
  );
  columns.push({
    ...{
      title: t("photo"),
      key: "photo",
      render: (text, record) => (
        <Space size="middle">
          {record.photo ? (
            <img
              style={{ width: 50, height: 50 }}
              src={
                "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                record.photo
              }
              onClick={() => openImageModal(record.photo, record.name)}
            ></img>
          ) : (
            t("no")
          )}
        </Space>
      ),
    },
  });
  columns.push({
    ...{
      title: t("action"),
      key: "action",
      render: (text, record) => (
        <div className="action-links-responsive">
          {(props?.user?.role === "4" ||
            props?.user?.role === "2" ||
            props?.user?.role === "9" ||
            props?.user?.role === "10") && (
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handleEditForm(record);
              }}
            >
              {t("update")}
            </Button>
          )}

          <Button
            type="text"
            size="small"
            className="action-link update-link"
            onClick={() => {
              handleViewForm(record.id);
            }}
          >
            {t("view1")}
          </Button>
          {(props?.user?.role === "4" ||
            props?.user?.role === "2" ||
            props?.user?.role === "9" ||
            props?.user?.role === "10") && (
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handlePreventiveViewForm(record.id);
              }}
            >
              {t("preventive")}
            </Button>
          )}

          {/* {props.cityid === record.city ? (
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handleActiveCriminal(record);
              }}
            >
              {record.activeUser && record.activeUser === 1 ? (
                <Tag color="green">{t("active")} </Tag>
              ) : (
                <Tag color="red">{t("in_active")} </Tag>
              )}
            </Button>
          ) : (
            ""
          )} */}
        </div>
      ),
    },
  });
  console.log("columns test", columns);
  const handleEditForm = (data) => {
    if (props.isAccusedFormUpdate && props.isAccusedFormUpdate) {
      props.onEditAccusedForm(data);
    } else {
      props.onEdituser(data);
    }
  };

  const handlePreventiveViewForm = (data) => {
    if (props.isAccusedFormUpdate && props.isAccusedFormUpdate) {
      props.onPreventiveViewAccusedForm(data);
    } else {
      props.onEdituser(data);
    }
    //props.onPreventiveViewAccusedForm(data);
  };

  const handleViewForm = (data) => {
    props.onViewAccusedDetails(data);
  };

  const handleActiveCriminal = (data) => {
    props.onCriminalActiveStatus(data);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setsearchText("");
  };
  console.log("props.search", props.search);
  const clear = () => {
    if (props.search) {
      props.clear();
    } else {
      setsearchText("");
    }
  };
  console.log("props.criminalRecords", props.criminalRecords);
  console.log("props.columns", props.columns);
  useMemo(() => {
    if (props.criminalRecords && props.criminalRecords) {
      let columns1 =
        props.criminalRecords &&
        props.criminalRecords &&
        props.criminalRecords.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
          };
        });

      // columns1 && columns1.length && columns1.reverse();
      console.log("props.cuurentpage", props.current);
      let tempObj = columns1?.map((res, index) => {
        return {
          ...res,
          photo:
            res.photo && res.photo[0] && res.photo[0].length
              ? res.photo[0]
              : null,
          "Sr.No": props.getSerialNumber(index, props.current, props.pageSize),
        };
      });
      setCriminalData(tempObj);

      let tablelabes = columns1 && columns1.length && Object.keys(columns1[0]);
      tablelabes && tablelabes.unshift("Sr.No");

      let tableColumns = [];
      tablelabes &&
        tablelabes.length &&
        tablelabes.forEach((item) => {
          if (
            _.filter(requiredKeys, function (o) {
              return o === item;
            }).length
          ) {
            tableColumns.push(item);
          }
        });

      let columnList = tableColumns.map((item, index) => {
        return {
          title: requiredKeysTitle[index],
          dataIndex: item,
          key: item,
        };
      });
      setCriminalHeaders(columnList);
    }
  }, [props.criminalRecords]);
  console.log("searchText", searchText);
  console.log("called componet new");
  console.log("find accessed", props);
  console.log("criminalData", criminalData);
  console.log("loading....", props.loading);
  return (
    <>
      <Table
        columns={columns}
        dataSource={criminalData}
        loading={props.loading}
        pagination={{
          current: props.currentPage,
          pageSize: props.pageSize,
          total: props.total,
          onChange: props.handlePageChange,
          has_previous: props.pageSize > 1,
          previous: props.pageSize - 1,
          has_next: props.pageSize < props.total,
          next: props.total + 1,
          last_page: Math.ceil(props.total / props.pageSize),
          onShowSizeChange: props.handlePageSizeChange,
          // showSizeChanger: true,
          // showQuickJumper: true,
        }}
      />

      {imageOpen && (
        <ImageView
          imageOpen={imageOpen}
          name={name}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + selectedImage
          }
          onClose={closeImageModal}
        />
      )}
      <Modal
        title={t("crime_information")}
        top
        visible={showGunaDetails}
        onOk={closeGunaViewModel}
        onCancel={closeGunaViewModel}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={props.professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(props?.professionals?.criminalViewList?.gunhaInfor) &&
            props?.professionals?.criminalViewList?.gunhaInfor.length > 0
              ? props?.professionals?.criminalViewList?.gunhaInfor
              : []
          }
          address={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].address
              : ""
          }
          name={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          loading={gunaLoading}
          user_details={props?.user}
          masterId={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props?.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaViewModel}
        ></ViewGunaDetails>
      </Modal>
    </>
  );
};

export default connect()(FindAccusedSearchTable);
